export const CheckCircleIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="10" fill="#E95D2C" />
            <path d="M5.83398 10.2503L8.75065 13.1669L14.1673 7.16699" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const InfoCircleIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="10" fill="#E95D2C" />
            <circle cx="10" cy="5.9" r="1.15" fill="white" />
            <path d="M10 9V14.2" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
    )
}

export const ResultArrowIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const ChevronDownIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
